// Mock data for MB Car Rentals

export const vehicles = [
  {
    id: 1,
    name: "Honda Fit (Yellow)",
    type: "Compact",
    price: 75,
    image: "https://customer-assets.emergentagent.com/job_island-rentals-8/artifacts/4bto73gx_Fit%20yellow.jpg",
    description: "Stylish and fuel-efficient compact car, perfect for navigating island roads.",
    features: ["5 Seats", "Automatic", "AC", "Bluetooth"]
  },
  {
    id: 2,
    name: "Honda Fit (Silver)",
    type: "Compact",
    price: 75,
    image: "https://customer-assets.emergentagent.com/job_island-rentals-8/artifacts/l3hybl9y_Fit.jpg",
    description: "Reliable and spacious compact car with excellent fuel economy.",
    features: ["5 Seats", "Automatic", "AC", "USB Ports"]
  },
  {
    id: 3,
    name: "Nissan Cube",
    type: "Compact",
    price: 80,
    image: "https://customer-assets.emergentagent.com/job_island-rentals-8/artifacts/f96qnf3s_Cube.jpg",
    description: "Unique and roomy design, ideal for comfortable island adventures.",
    features: ["5 Seats", "Automatic", "AC", "GPS"]
  },
  {
    id: 4,
    name: "Nissan X-Trail (Black)",
    type: "SUV",
    price: 100,
    image: "https://customer-assets.emergentagent.com/job_island-rentals-8/artifacts/vrbfshd1_Xtrail%20black.jpg",
    description: "Powerful SUV perfect for family trips and exploring The Bahamas.",
    features: ["7 Seats", "Automatic", "AC", "4WD"]
  },
  {
    id: 5,
    name: "Nissan X-Trail (White)",
    type: "SUV",
    price: 100,
    image: "https://customer-assets.emergentagent.com/job_island-rentals-8/artifacts/hd4x7a8v_Xtrail.jpg",
    description: "Spacious and reliable SUV for all your island transportation needs.",
    features: ["7 Seats", "Automatic", "AC", "Cruise Control"]
  }
];

export const reviews = [
  {
    id: 1,
    name: "Sarah Johnson",
    rating: 5,
    comment: "Excellent service! The car was clean and the rental process was so easy. Highly recommend MB Car Rentals!",
    date: "2024-01-15",
    location: "Nassau"
  },
  {
    id: 2,
    name: "Michael Chen",
    rating: 5,
    comment: "Best car rental experience in The Bahamas. Affordable prices and friendly staff. Will definitely rent again!",
    date: "2024-01-10",
    location: "Paradise Island"
  },
  {
    id: 3,
    name: "Emma Williams",
    rating: 5,
    comment: "Amazing service from start to finish. The SUV was perfect for our family vacation. Thank you MB Car Rentals!",
    date: "2024-01-05",
    location: "Cable Beach"
  }
];

export const whyChooseUs = [
  {
    icon: "DollarSign",
    title: "Affordable Prices",
    description: "Competitive rates without compromising on quality or service."
  },
  {
    icon: "Car",
    title: "Reliable Vehicles",
    description: "Well-maintained fleet of modern vehicles for your safety."
  },
  {
    icon: "Clock",
    title: "Easy Booking",
    description: "Quick and simple reservation process, online or by phone."
  },
  {
    icon: "Users",
    title: "Friendly Service",
    description: "Dedicated team ready to assist you with a smile."
  },
  {
    icon: "Zap",
    title: "Fast & Efficient",
    description: "Quick pickup and drop-off to maximize your vacation time."
  },
  {
    icon: "Shield",
    title: "Fully Insured",
    description: "Comprehensive insurance coverage for your peace of mind."
  }
];

export const contactInfo = {
  phone: "+1 (242) 425-6523",
  phone2: "+1 (242) 477-4050",
  email: "mbcarrentals242@gmail.com",
  address: "Eleuthera, Palmetto Point, The Bahamas",
  hours: "Mon-Sun: 7:00 AM - 9:00 PM",
  social: {
    facebook: "https://facebook.com/mbcarrentals",
    instagram: "https://instagram.com/mbcarrentals",
    twitter: "https://twitter.com/mbcarrentals"
  }
};